import { gql } from '@apollo/client';

export const getHomeData = gql`{
    getHomeData {
      result {
        id
        title
        content
        isEnable
        getHomeBanner {
          id
          name
          enable
        }
      }
    }
  }`;

export const getServiceFees = gql`
    query getServiceFees{
      getServiceFees{
          id
          guestType
          guestValue
          hostType
          hostValue
          currency
          status
      }
    }
    `;

export const checkMapQuery = `
    query ($address: String) {
      locationItem(address: $address) {
        lat
        lng
        status
      }
    }
    `;

export const changeForgotPassword = gql`
    mutation changeForgotPassword($email: String!, $newPassword: String!) {
     changeForgotPassword (email: $email, newPassword: $newPassword) {
       status
     }
    }
    `;

export const content = `
    query($path:String!,$locale:String!) {
      content(path:$path,locale:$locale) {
        title, content,
      }
    }
    `;

export const locationItem = gql`
    query ($address: String) {
      locationItem(address: $address) {
        street
        city
        state
        country
        zipcode
        lat
        lng
      }
    }
    `;

export const intl = `
    query ($locale:String!) {
      intl (locale:$locale) {
        id
        message
      }
    }
    `;

export const deleteWishListGroup = gql`
    mutation DeleteWishListGroup(
        $id: Int!,
    ){
        DeleteWishListGroup(
            id: $id
        ) {
            status
        }
    }
    `;

export const addPhoneNumber = gql`
      mutation AddPhoneNumber($countryCode: String!, $phoneNumber: String!, $countryName: String,$userId:String) {
          AddPhoneNumber(countryCode: $countryCode, phoneNumber: $phoneNumber, countryName: $countryName,userId:$userId) {
              status
              countryCode
              phoneNumber
              userProfileNumber
        }
       }
    `;

export const updateServiceFees = gql`
    mutation updateServiceFees(
      $guestType: String!, 
      $guestValue: Float!,
      $hostType: String!,
      $hostValue: Float!,
      $currency: String,
    ){
        updateServiceFees(
          guestType: $guestType,
          guestValue: $guestValue,
          hostType: $hostType,
          hostValue: $hostValue,
          currency: $currency
        ) {
            id
            guestType
            guestValue
            hostType
            hostValue
            currency
            status
        }
    }
    `;

export const sendContactEmail = `
    mutation sendContactEmail(
        $phoneNumber: String,
        $name: String,
        $email: String,
        $ContactMessage: String
      ){
          sendContactEmail(
            phoneNumber: $phoneNumber,
            name: $name,
            email: $email,
            ContactMessage: $ContactMessage
          ) {
              status
          }
    }
    `;

export const autocompleteQuery = gql`
  query AutocompleteQuery($input: String!, $limit: Int) {
    autocomplete(input: $input, limit: $limit) {
      status
      results {
        id
        name
        type
        description
        lat
        lng
      }
      errorMessage
    }
  }
`;

export const autocompleteLocationsQuery = gql`
  query AutocompleteLocationsQuery {
    autocompleteLocations
  }
`;